"use strict";
var AnimationFrameScheduler_1 = require('./AnimationFrameScheduler');
exports.animationFrame = new AnimationFrameScheduler_1.AnimationFrameScheduler();
//# sourceMappingURL=animationFrame.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/rxjs/scheduler/animationFrame.js
 ** module id = 898
 ** module chunks = 0
 **/